<script setup lang="ts">
const props = defineProps<{
  lineId?: number | null
  setNid?: number | null
}>()

const { data: files, pending } = await useLazyAsyncData(
  () => createProductSetsRepository().getFiles(props.setNid),
  {
    transform: (data) => data.items,
  }
)
</script>

<template>
  <DownloadWidget v-if="!pending" :files="files ?? []" :line-id="lineId" />
</template>
